// extracted by mini-css-extract-plugin
module.exports = {"date":"ProcedureTableInfo_date__12V6Q","head":"ProcedureTableInfo_head__1P_ML"};